import { render } from "./NomEditAdresaLivrare.vue?vue&type=template&id=2a6f7d88&scoped=true&ts=true"
import script from "./NomEditAdresaLivrare.ts?vue&type=script&lang=ts"
export * from "./NomEditAdresaLivrare.ts?vue&type=script&lang=ts"

import "./NomEditAdresaLivrare.vue?vue&type=style&index=0&id=2a6f7d88&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalBG\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6f7d88"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput,QBtn});
